<template>
  <div>
    <v-row justify="space-between" no-gutters align="end">
      <v-col cols="auto">
        <div class="mb-1 subtitle-1 font-weight-bold">Links</div>
      </v-col>
      <v-btn
        min-width="41"
        width="41"
        height="41"
        tile
        text
        class="primary px-0 d-inline-block"
        @click.prevent="addLink"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </v-row>

    <v-card
      outlined
      tile
      v-for="(link, index) in links"
      :key="index"
      class="mb-4"
    >
      <v-card-text>
        <v-btn
          large
          color="primary"
          dark
          tile
          outlined
          right
          absolute
          id="delete-link"
          @click="
            dialogDelete = true;
            deletedID = index;
          "
          >Delete</v-btn
        >
        <v-checkbox
          color="primary"
          v-model="link.active"
          dense
          smalls
          on-icon="mdi-square"
          off-icon="mdi-square-outline"
          class="mt-0 mb-6 d-inline-block"
        >
          <template v-slot:label>
            <div
              :class="[
                link.active ? 'black--text' : 'gray--text',
                'subheading-1',
              ]"
            >
              active
            </div>
          </template>
        </v-checkbox>
        <v-text-field
          label="Display name"
          v-model="link.name"
          dense
        ></v-text-field>
        <v-text-field label="Url" v-model="link.url" dense></v-text-field>
      </v-card-text>
      <!-- </div> -->
    </v-card>
    <v-dialog max-width="290" v-model="dialogDelete">
      <v-card>
        <v-card-title class="headline">Remove link</v-card-title>
        <v-card-text>Are you sure?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey " text @click="dialogDelete = false">Cancel</v-btn>
          <v-btn color="primary " text @click="removeLink">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "Banners",
  data() {
    return {
      dialogDelete: false,
      deletedID: null,
    };
  },
  props: ["links"],
  methods: {
    removeLink() {
      this.links.splice(this.deletedID, 1);
      this.dialogDelete = false;
    },
    addLink() {
      this.links.push({
        name: "",
        url: "",
        active: false,
        dialogDelete: false,
      });
    },
  },
});
</script>

<style></style>
